// extracted by mini-css-extract-plugin
export default {"main":"UploadedFilesTable_main__5XjnX","name":"UploadedFilesTable_name__fl+R4","icon":"UploadedFilesTable_icon__chOe-"};